module.exports = __webpack_public_path__ + "media/img/favicon-32x32-a853222c6e23cd390e7242819186d302.png";